import claudeLogo from "~/assets/claude-logo.svg";
import geminiLogo from "~/assets/gemini-logo.svg";
import googleAiModeLogo from "~/assets/google-ai-mode-logo.svg";
import googleAiOverviewsLogo from "~/assets/google-ai-overviews-logo.svg";
import grokLogo from "~/assets/grok-logo.svg";
import msCopilotLogo from "~/assets/ms-copilot-logo.svg";
import openaiLogo from "~/assets/openai-logo.svg";
import perplexityLogo from "~/assets/perplexity-logo.svg";

export function normalizeLlmPlatformKey(name: string): string {
  return name.trim().toLowerCase();
}

const DISPLAY_LABEL_BY_KEY: Record<string, string> = {
  chatgpt: "ChatGPT",
  claude: "Claude",
  gemini: "Gemini",
  perplexity: "Perplexity",
  google_ai_overviews: "Google AI Overviews",
  google_ai_mode: "Google AI Mode",
  copilot: "Microsoft Copilot",
  grok: "Grok",
  meta_ai: "Meta AI",
  kimi: "Kimi",
  qwen: "Qwen",
  mistral: "Mistral",
  deepseek: "DeepSeek",
};

const LOGO_BY_KEY: Record<string, string> = {
  chatgpt: openaiLogo,
  claude: claudeLogo,
  gemini: geminiLogo,
  perplexity: perplexityLogo,
  google_ai_overviews: googleAiOverviewsLogo,
  google_ai_mode: googleAiModeLogo,
  copilot: msCopilotLogo,
  grok: grokLogo,
};

const SCRAPE_DOCUMENT_BASE_BY_KEY: Record<string, string> = {
  chatgpt: "https://chatgpt.com/",
  gemini: "https://gemini.google.com/",
  perplexity: "https://www.perplexity.ai/",
  google_ai_overviews: "https://www.google.com/",
  google_ai_mode: "https://google.com/aimode",
  copilot: "https://copilot.microsoft.com/",
  grok: "https://grok.x.com/",
};

export function llmPlatformDisplayLabel(name: string): string {
  const key = normalizeLlmPlatformKey(name);
  return DISPLAY_LABEL_BY_KEY[key] ?? name;
}

const COLOR_BY_KEY: Record<string, string> = {
  chatgpt: "#10a37f",
  gemini: "#4c7df0",
  google_ai_overviews: "#e8a200",
  google_ai_mode: "#8b5cf6",
  claude: "#d97757",
  perplexity: "#20808d",
  copilot: "#0078d4",
  grok: "#71717a",
};

export function llmPlatformColor(name: string): string {
  return COLOR_BY_KEY[normalizeLlmPlatformKey(name)] ?? "#a1a1aa";
}

export function llmPlatformLogoSrc(name: string): string | null {
  const key = normalizeLlmPlatformKey(name);
  return LOGO_BY_KEY[key] ?? null;
}

export function scrapePlatformBaseUrlForLlmName(
  llmName: string
): string | null {
  const key = normalizeLlmPlatformKey(llmName);
  return SCRAPE_DOCUMENT_BASE_BY_KEY[key] ?? null;
}
